const services = [
  {
    id: 1,
    title: 'TPO Roofing Systems',
    description:
      'Thermoplastic Polyolefin single-ply membranes offer outstanding energy efficiency, heat-welded seams, and resistance to UV, chemicals, and punctures. Ideal for NJ commercial properties.',
    image: 'https://public.readdy.ai/ai/img_res/362d49e8d2fcbb2ae878b47d374dc56e.jpg',
  },
  {
    id: 2,
    title: 'EPDM Rubber Roofing',
    description:
      'Highly durable synthetic rubber membrane perfect for large commercial flat roofs. Excellent resistance to extreme weather — critical for New Jersey\'s harsh winters and summer heat.',
    image: 'https://readdy.ai/api/search-image?query=EPDM%20black%20rubber%20membrane%20flat%20roof%20on%20commercial%20warehouse%20building%2C%20professional%20roofers%20installing%20rubber%20roofing%2C%20wide%20flat%20rooftop%20view%2C%20industrial%20setting%2C%20clear%20daytime%20construction%20photography&width=600&height=400&seq=svc-epdm-nj-01&orientation=landscape',
  },
  {
    id: 3,
    title: 'Modified Bitumen',
    description:
      'A proven asphalt-based system reinforced with polyester or fiberglass. Excellent waterproofing performance and added flexibility makes it a top choice for NJ commercial flat roofs.',
    image: 'https://readdy.ai/api/search-image?query=modified%20bitumen%20roofing%20installation%20on%20commercial%20building%2C%20roofer%20applying%20torch-applied%20bitumen%20membrane%2C%20flat%20rooftop%2C%20professional%20construction%20photography%2C%20industrial%20background%2C%20daytime%20natural%20lighting&width=600&height=400&seq=svc-modbit-nj-01&orientation=landscape',
  },
  {
    id: 4,
    title: 'Emergency Roof Repair',
    description:
      'Water doesn\'t wait — and neither do we. Our 24-hour emergency response team is dispatched across all of New Jersey to stop leaks fast and prevent costly interior damage.',
    image: 'https://readdy.ai/api/search-image?query=emergency%20roofing%20crew%20repairing%20commercial%20flat%20roof%20leak%20at%20nighttime%2C%20workers%20with%20flashlights%20and%20equipment%20on%20rooftop%2C%20urgency%20and%20professionalism%2C%20dramatic%20lighting%2C%20professional%20construction%20photography&width=600&height=400&seq=svc-emergency-nj-01&orientation=landscape',
  },
  {
    id: 5,
    title: 'Roof Coatings & Restoration',
    description:
      'Extend the life of your existing flat roof with an elastomeric or silicone coating. A cost-effective alternative to full replacement with reflective benefits that reduce cooling costs.',
    image: 'https://readdy.ai/api/search-image?query=commercial%20flat%20roof%20under%20active%20construction%20unfinished%20rooftop%20with%20exposed%20insulation%20boards%20and%20partially%20laid%20waterproof%20membrane%20roofing%20crew%20working%20with%20tools%20and%20materials%20scattered%20across%20large%20industrial%20building%20daylight&width=600&height=400&seq=svc-wip-v3&orientation=landscape',
  },
  {
    id: 6,
    title: 'Roof Inspections',
    description:
      'Our on-staff engineer performs thorough structural and waterproofing assessments. Detailed inspection reports keep you informed and help you plan maintenance before problems escalate.',
    image: 'https://readdy.ai/api/search-image?query=professional%20roofing%20engineer%20in%20hard%20hat%20inspecting%20commercial%20flat%20roof%20with%20clipboard%20and%20equipment%2C%20daytime%20urban%20new%20jersey%20skyline%20background%2C%20professional%20construction%20engineering%20photography&width=600&height=400&seq=svc-inspect-nj-01&orientation=landscape',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-14">
          <div>
            <p className="text-xs tracking-widest text-orange-600 uppercase mb-3">What we do</p>
            <h2 className="text-4xl md:text-5xl font-display font-black text-gray-900 tracking-tight">
              Commercial Flat<br />Roofing Services
            </h2>
          </div>
          <p className="text-sm text-gray-500 max-w-xs leading-relaxed">
            Knowledgeable in all new and legacy roofing systems — we'll recommend the best solution for your building.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {services.map((s) => (
            <div key={s.id} className="group flex flex-col cursor-pointer">
              <div className="w-full h-52 overflow-hidden mb-5">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-base font-medium text-gray-900 mb-2">{s.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed flex-1">{s.description}</p>
              <button className="mt-4 text-xs text-orange-600 underline underline-offset-4 hover:text-orange-800 transition-colors cursor-pointer text-left whitespace-nowrap w-fit">
                Learn more &rarr;
              </button>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
